import Head from "next/head";
import type {NextPage} from "next";
import {useCookies} from "react-cookie";
import {handleLogout} from "components/utils"; import React from "react";
import {ClientIndependentView} from "../components/client/self/ClientIndependentView";
import {ClientIndependentOpdView} from "../components/client/self/ClientIndependentOpdView";

const ClientOpd: NextPage = (props) => {

    const [cookies, setCookie] = useCookies(['qme']);
    const cookiePhoneNumber = cookies.qme ? cookies.qme["phone"] : null
    const cookieQr = cookies.qme ? cookies.qme["qr"] : null

    return (
        <div>
            <Head>
                <title>QMe - Doctor&apos; Patient management</title>
                <meta name="description" content="QMe - Patient management system"/>
                <meta name="keywords" content="opd management software"/>
                <meta name="robots" content="noindex, nofollow"/>
            </Head>
            <div className="row bg-white">

                <div className="px-3">
                    <ClientIndependentOpdView cookiePhoneNumber={cookiePhoneNumber} cookieQr={cookieQr}
                                           qmeEnabled={true}/>
                </div>
            </div>

        </div>
    );
};


export default ClientOpd;
